import { memo } from "react";
import { TableMeta } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ChartOfAccountsRow } from "../utils";
import { ChartOfAccountsItemActions } from "../ChartOfAccountsItemActions";
import { GroupActions } from "../GroupActions";
import { ChartOfAccountsTableMeta } from "../ChartOfAccounts";

type ActionsCellMeta = TableMeta<ViewTableFeatures, ChartOfAccountsRow> &
    Partial<Pick<ChartOfAccountsTableMeta, "callbacks">>;

export interface ChartOfAccountsActionsCellProps {
    row: { original: ChartOfAccountsRow };
    table: { options: { meta?: ActionsCellMeta } };
}

export const ActionsCell = memo(
    ({ row, table }: ChartOfAccountsActionsCellProps) => {
        const rowData = row.original;
        const meta = table.options.meta;
        const callbacks = meta?.callbacks;

        // Classification row - no actions
        if (rowData.classification) {
            return <ViewTableCell />;
        }

        // Group row
        if (rowData.group && callbacks) {
            const similarGroups = rowData.similarGroups ?? [];
            return (
                <ViewTableCell captureClicks>
                    {similarGroups.length > 0 && (
                        <GroupActions
                            group={rowData.group}
                            similarGroups={similarGroups}
                            openEditorForRow={callbacks.openEditorForRow}
                        />
                    )}
                </ViewTableCell>
            );
        }

        // Account row
        if (rowData.account && rowData.groupKey && callbacks) {
            return (
                <ViewTableCell captureClicks>
                    <ChartOfAccountsItemActions
                        account={rowData.account}
                        similarAccounts={rowData.similarAccounts ?? []}
                        openEditorForRow={callbacks.openEditorForRow}
                    />
                </ViewTableCell>
            );
        }

        return <ViewTableCell />;
    },
);
